import { render, staticRenderFns } from "./CarouselPhoto.vue?vue&type=template&id=3de9b1c7&"
import script from "./CarouselPhoto.vue?vue&type=script&lang=ts&"
export * from "./CarouselPhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports